import axios from 'axios'
// import $store from '../store'
const apiURL = process.env.NODE_ENV === 'development' ? '/ticket-api' : ''

export class ApiService {
  // static async listCustomisedByOrganisation () {
  //   const domain = process.env.NODE_ENV === 'development' ? 'tollywood-dev.eigaland.com' : $store.state.organization.domain
  //   const response = await axios.get(`${apiURL}/api/website/customised/list`, { params: { domain } })
  //   return response.data
  // }

  static async getCinemaDetail (id) {
    // const domain = process.env.NODE_ENV === 'development' ? 'tollywood-dev.eigaland.com' : $store.state.organization.domain
    const response = await axios.get(`${apiURL}/api/schedulePage/getCinemaDetail`, { params: { webKey: id } })
    return response.data
  }

  // static async findMovieDetail (movieId) {
  //   const response = await axios.get(`${apiURL}/api/website/movie/detail/${movieId}`)
  //   return response.data
  // }

  // static async findMovieList (type, page = 0) {
  //   const domain = process.env.NODE_ENV === 'development' ? 'tollywood-dev.eigaland.com' : $store.state.organization.domain
  //   const response = await axios.get(`${apiURL}/api/website/movie/list`, { params: { domain, type, page } })
  //   return response.data
  // }

  // static async findNewsDetail (newsId) {
  //   const response = await axios.get(`${apiURL}/api/website/news/detail/${newsId}`)
  //   return response.data
  // }

  // static async listNewsByOrganisationAndDate (publishYear, category, page = 0) {
  //   const domain = process.env.NODE_ENV === 'development' ? 'tollywood-dev.eigaland.com' : $store.state.organization.domain
  //   const response = await axios.get(`${apiURL}/api/website/news/list`,
  //     { params: { domain, publishYear, category, page } })
  //   return response.data
  // }

  // static async listByMovieAndDate (movieId, date) {
  //   const response = await axios.get(`${apiURL}/api/website/show/listByMovieAndDate`,
  //     { params: { movieId, date } })
  //   return response.data
  // }

  static async listByDomainAndDate (id, date) {
    // const domain = process.env.NODE_ENV === 'development' ? 'tollywood-dev.eigaland.com' : $store.state.organization.domain
    const response = await axios.get(`${apiURL}/api/schedulePage/show/listByCinemaIdAndDate`,
      { params: { webKey: id, date } })
    return response
  }
}
